import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, ref, watch } from "vue";
  import Cleave from "vue-cleave-component";
  import ToggleButton from "@/components/ui/ToggleButton.vue";
  import useVuelidate from "@vuelidate/core";
  import {
    helpers,
    maxLength,
    minLength,
    required,
    minValue,
  } from "@vuelidate/validators";
  import store from "@/store";
  import router from "@/router";
  import { CreateEstate } from "@/types/CreateEstate";
  import { latinCharactersRegex } from "@/helpers/regex";
  import getUserRole from "@/helpers/getUserRole";
  import { EstateType } from "@/enums/EstateType";
  import { EstateAppVersion } from "@/enums/EstateAppVersion";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminEstateCreate',
  setup(__props, { expose: __expose }) {
  __expose();

  const { isSuperAdmin } = getUserRole();
  const initDepositOptions = {
    numeral: true,
    numeralThousandsGroupStyle: "thousand",
    prefix: "$",
    rawValueTrimPrefix: true,
  };
  const userId = router.currentRoute.value.params.userId;
  const form = reactive<CreateEstate>({
    title: "",
    address: "",
    isRefundable: true,
    landownerId: userId as string,
    iconColor: "#8f00ff",
    shortTitle: "",
    initDeposit: 0,
    showInitialHold: false,
    showDocusign: false,
    appVersion: EstateAppVersion.V2,
  });
  const latinCharacters = helpers.regex(latinCharactersRegex);
  const rules = computed(() => {
    return {
      initDeposit: {
        required,
        minValue: minValue(getMinDepositValue.value),
      },
      shortTitle: {
        required,
        maxLength: maxLength(9),
        minLength: minLength(1),
      },
      title: {
        required,
        latinCharacters: helpers.withMessage("Invalid value", latinCharacters),
        $autoDirty: true,
      },
      address: { required, $autoDirty: true },
      type: { required },
      appVersion: { required },
    };
  });

  const getMinDepositValue = computed(() => {
    return initDepositCondition.value ? 1 : 0;
  });

  const initDepositCondition = ref(true);
  const isAppVersionLocked = computed(() => {
    return (
      form.type === EstateType.LEGACY ||
      form.type === EstateType.RESIDENTIAL_COMMUNITY ||
      form.type === EstateType.LAND_SUBDIVISION
    );
  });

  const v$ = useVuelidate(rules, form);

  watch(
    () => form.type,
    (type) => {
      syncAppVersionWithEstateType(type);
    }
  );

  const syncAppVersionWithEstateType = (type = form.type) => {
    if (type === EstateType.LEGACY) {
      form.appVersion = EstateAppVersion.V1;
      return;
    }

    if (
      type === EstateType.RESIDENTIAL_COMMUNITY ||
      type === EstateType.LAND_SUBDIVISION
    ) {
      form.appVersion = EstateAppVersion.V2;
    }
  };

  const createEstate = async () => {
    syncAppVersionWithEstateType();
    v$.value.$touch();
    const isFormCorrect = await v$.value.$validate();

    if (!isFormCorrect) {
      return;
    }

    const { initDeposit, ...props } = form;
    const normalizedForm = {
      initDeposit: initDeposit * 100,
      ...props,
    };

    store.dispatch("estate/createEstate", normalizedForm).then(() => {
      router.push({
        name: "AdminUser",
        params: { userId },
      });
    });
  };

  const setDepositAndRefundable = () => {
    if (initDepositCondition.value) {
      form.isRefundable = true;
    } else {
      form.initDeposit = 0;
      form.isRefundable = false;
    }
  };

const __returned__ = { isSuperAdmin, initDepositOptions, userId, form, latinCharacters, rules, getMinDepositValue, initDepositCondition, isAppVersionLocked, v$, syncAppVersionWithEstateType, createEstate, setDepositAndRefundable, computed, reactive, ref, watch, get Cleave() { return Cleave }, ToggleButton, get useVuelidate() { return useVuelidate }, get helpers() { return helpers }, get maxLength() { return maxLength }, get minLength() { return minLength }, get required() { return required }, get minValue() { return minValue }, get store() { return store }, get router() { return router }, get CreateEstate() { return CreateEstate }, get latinCharactersRegex() { return latinCharactersRegex }, get getUserRole() { return getUserRole }, get EstateType() { return EstateType }, get EstateAppVersion() { return EstateAppVersion } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})